import React, { useState, useEffect, useMemo } from 'react';
import UsersList from '../../../../components/UsersList';
import { getResidentUserDetails } from '../../../../utils/services/userService';
import { showErrorAlert } from '../../../../utils/alerts';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [searchUser, setSearchUser] = useState('');

  const filteredUsers = useMemo(() => {
    const search = (searchUser || '').toLowerCase();

    return users.filter((item) => {
      const { cedula, name, email, tags, apartmentName, buildingName } = item.user;

      return (
        (cedula && cedula.toString().toLowerCase().includes(search)) ||
        (name && name.toLowerCase().includes(search)) ||
        (email && email.toLowerCase().includes(search)) ||
        (Array.isArray(tags) &&
          tags.some(
            (t) =>
              (t?.tag && t.tag.toLowerCase().includes(search)) || (t?.type && t.type.toLowerCase().includes(search)),
          )) ||
        (apartmentName && apartmentName.toLowerCase().includes(search)) ||
        (buildingName && buildingName.toLowerCase().includes(search))
      );
    });
  }, [users, searchUser]);

  const getResidents = async () => {
    try {
      const users = await getResidentUserDetails();

      setUsers(users);
    } catch (error) {
      console.error('Error', error);
      showErrorAlert('Error', error.message);
    }
  };

  useEffect(() => {
    getResidents();
  }, []);

  return (
    <div>
      <div className="mb-3 row w-100 text-form">
        <h2>Administrar usuarios</h2>
      </div>
      <div className="d-flex justify-content-start mb-4">
        <input
          type="text"
          placeholder="Buscar residente"
          value={searchUser}
          onChange={(e) => {
            const value = e.target.value;
            setSearchUser(value);
          }}
          className="w-50 p-3 border rounded"
        />
      </div>
      <UsersList users={filteredUsers} onUserSave={getResidents} />
    </div>
  );
};

export default UserManagement;
